import { IBase } from 'src/app/core';

export interface IFile extends IBase {
  dateOfTaking: string;
  lvet: number;
  pep: number;
  ivct: number;
  hr: number | null;
  spo2: number | null;
  ntProBnp: number;
  offset?: number;
}
